import React from "react";
import ReactDOM from "react-dom/client";
import Program from "./uni-questionnaire/Program";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
// import './hack.js';
import "./i18n";
import "dayjs/locale/zh-cn";
import "dayjs/locale/zh-tw";
import "dayjs/locale/ja";
import "dayjs/locale/id";
import "dayjs/locale/ko";
import "dayjs/locale/th";
import "dayjs/locale/vi";
import "dayjs/locale/en";
import "dayjs/locale/tl-ph";

console.log("ENV:", process.env.REACT_APP_ENV_NAME);
console.log("ver:", "2024-05-09-B");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Program />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
